import React from 'react'

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Container size variant
   */
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full'
  /**
   * Container padding
   */
  padding?: 'none' | 'sm' | 'md' | 'lg'
  /**
   * Container content
   */
  children: React.ReactNode
}

const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  (
    {
      size = 'lg',
      padding = 'md',
      children,
      className = '',
      ...props
    },
    ref
  ) => {
    const baseClasses = [
      'w-full',
      'mx-auto'
    ]

    const sizeClasses = {
      sm: ['max-w-2xl'],
      md: ['max-w-4xl'],
      lg: ['max-w-6xl'],
      xl: ['max-w-7xl'],
      full: ['max-w-full']
    }

    const paddingClasses = {
      none: [],
      sm: ['px-4'],
      md: ['px-4', 'sm:px-6'],
      lg: ['px-4', 'sm:px-6', 'lg:px-8']
    }

    const containerClasses = [
      ...baseClasses,
      ...sizeClasses[size],
      ...paddingClasses[padding],
      className
    ].join(' ')

    return (
      <div
        ref={ref}
        className={containerClasses}
        {...props}
      >
        {children}
      </div>
    )
  }
)

Container.displayName = 'Container'

export { Container }
